import { triggerTracking } from '@zoopla/tracking';

export const trackSaveThisSearch = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'clickthrough',
        eventLabel: 'save_search'
    });
};

export const trackCreateEmailAlert = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'clickthrough',
        eventLabel: 'alert_click'
    });
};
